var LoadMore = (function() {
	'use strict';

	var _$container;
	var _$button;
	var initOffset;
	var maxPosts;
	var postPieces;
	var tweenOptions = {
		clip: 'clip: rect(0px 900px 400px 0px)',
		delay:0.5,
		ease:Quad.easeOut,
		force3D:true
	};

	function init() {
		// Set init vars
		_$container = $(".featured-post");
		_$button = $('.button--load-more');
		initOffset = _$button.data('offset');

		// get current page ID
		var pageID;
		var bodyClasses = document.body.className.split(' ');

		for (var i = 0; i < bodyClasses.length; i++) {
			if (bodyClasses[i].substr(0,7) === 'page-id') {
				pageID = bodyClasses[i].replace('page-id-', '');
			}
		}

		$.get('/wp-json/acf/v2/page/' + pageID + '/modules', function(data) {

			for (var i = 0; i < data.modules.length; i++) {
				var module = data.modules[i];

				if (module.acf_fc_layout === 'work' || module.acf_fc_layout === 'blog_posts') {
					postPieces = module.work;
				}
			}

			maxPosts = postPieces.length;

			var initArray = postPieces.slice(0, initOffset);
			var initHTML = getHtmlFromACF(initArray);

			_$container.append(initHTML);

			_$container.imagesLoaded({background: true}, function() {
				$('.featured-post__hidden').removeClass('featured-post__hidden');
				TweenMax.staggerFrom(_$container.find('.featured-post__post__clipper'), .5, tweenOptions, 0.2);
			});

			postPieces.splice(0, initOffset);

			init_events();
		});
	}

	function getHtmlFromACF(workArray) {

		var html = '';

		for (var i = 0; i < initOffset; i++) {
			var w = workArray[i];

			if (typeof w === 'undefined') {
				continue;
			}

			html += '<div class="featured-post__post featured-post__hidden" style="background-image: url(' + w.image + ');"><div class="featured-post__post__clipper"></div><a class="post-link" href="' + w.button_destination.post_permalink + '"><div class="content">';

			for (var j = 0; j < w.headline.length; j++) {
				var newLineText = w.headline[j].line;

				if (newLineText.length > 0) {
					html += '<span>' + newLineText + '</span>';
				}
			}

			if ( w.button_text !== '' && w.button_destination.post_permalink !== '' ) {
				html += '<span class="subline">' + w.button_text + '</span>';
			}

			html += '</div><!-- /.content --></a></div>';
		}

		return html;

	}

	function init_events() {

		_$button.on('click', function() {

			_$button.attr('disabled', true);

			var currentOffset = _$button.data('offset');
			var workToAdd = postPieces.slice(0, initOffset); // Adding this as a var so we can count it for animation
			var html = getHtmlFromACF(workToAdd);

			_$container.append(html);

			var elsArray = [].slice.call(_$container.find('.featured-post__post__clipper'));

			elsArray.splice(0, elsArray.length - workToAdd.length);

			_$container.imagesLoaded(function() {
				$('.featured-post__hidden').removeClass('featured-post__hidden');
				TweenMax.staggerFrom(elsArray, .5, tweenOptions, 0.2);
			});

			postPieces.splice(0, initOffset);

			_$button.data('offset', currentOffset + initOffset);
			_$button.attr('disabled', false);

			if (postPieces.length <= 0) {
				scrollHandler.destroy();
				_$button.remove();
			}

		});
	}

	return {
		init:init
	};
}());
